var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glide-Path_-Body-View",
    transform: "translate(-320.000000, -602.000000)",
    fill: "#2BA0F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action-Card",
    transform: "translate(0.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action-Card-Content",
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Full-Plan-BTN",
    transform: "translate(281.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6378203,0.0952819527 C32.4136992,-0.0309199878 32.1371602,-0.0318065726 31.912125,0.092929093 L26.9854336,2.82357627 L21.3168398,0.0744813086 C21.0993633,-0.0309881866 20.8419844,-0.0240660051 20.6309062,0.092929093 L15.3663281,3.01081616 C15.1398164,3.13643841 15,3.37008762 15,3.62317349 L15,15.2947559 C15,15.5461368 15.1379883,15.7785243 15.3621445,15.9047603 C15.5863711,16.0308941 15.8628398,16.0318148 16.087875,15.9070791 L21.0145664,13.176466 L26.6831602,15.925561 C26.7857109,15.9752779 26.8970859,16 27.0083203,16 C27.1330195,16 27.257543,15.9688672 27.3690938,15.9070791 L32.6336719,12.989192 C32.8601836,12.8636039 33,12.6299206 33,12.3768688 L33,0.705286415 C33,0.453871417 32.8620117,0.221483893 32.6378203,0.0952819527 Z M31.5457969,11.9675735 L26.9854687,14.4951587 L21.316875,11.7460637 C21.2143242,11.6963467 21.1029492,11.6716247 20.9917148,11.6716247 C20.8670156,11.6716247 20.7424922,11.7027233 20.6309414,11.7645456 L16.4542031,14.0794527 L16.4542031,4.03243468 L21.0145312,1.50488363 L26.683125,4.25394449 C26.9006367,4.35941399 27.1580156,4.35245771 27.3690586,4.23549671 L31.5457969,1.92055552 L31.5457969,11.9675735 L31.5457969,11.9675735 Z M20.9916797,4.228238e-05 C20.590125,4.228238e-05 20.2645781,0.315802879 20.2645781,0.705286415 L20.2645781,12.3768688 C20.2645781,12.7663864 20.590125,13.0821129 20.9916797,13.0821129 C21.3932344,13.0821129 21.7187813,12.7663864 21.7187813,12.3768688 L21.7187813,0.705286415 C21.7187813,0.315802879 21.3932344,4.228238e-05 20.9916797,4.228238e-05 Z M27.0083203,2.91792935 C26.6067305,2.91792935 26.2812188,3.23368995 26.2812188,3.62317349 L26.2812188,15.2947559 C26.2812188,15.6842735 26.6067305,16 27.0083203,16 C27.4099102,16 27.7354219,15.6842394 27.7354219,15.2947559 L27.7354219,3.62317349 C27.7354219,3.23368995 27.4099102,2.91792935 27.0083203,2.91792935 Z",
    id: "Icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/plan-icon.5ce9a36b.svg";
export { ForwardRef as ReactComponent };